import { render } from "./Bridge.vue?vue&type=template&id=0fcfb5ce"
import script from "./Bridge.vue?vue&type=script&lang=ts"
export * from "./Bridge.vue?vue&type=script&lang=ts"
script.render = render

export default script